module.exports = __webpack_public_path__ + "img/faq1.0ffb89b9.png";